import { render, staticRenderFns } from "./JobIcon.vue?vue&type=template&id=1fec35a9&scoped=true&"
import script from "./JobIcon.vue?vue&type=script&lang=ts&"
export * from "./JobIcon.vue?vue&type=script&lang=ts&"
import style0 from "./JobIcon.vue?vue&type=style&index=0&id=1fec35a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fec35a9",
  null
  
)

export default component.exports